import React, {useEffect} from 'react';
import ReactModalContent from '../Shared/Modal/ReactModalContent';
import Table from "../Shared/Table";
import styled from 'styled-components';
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import {testTaxRateData} from "../../utils/testTaxRateData";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import {UseAppDispatch, UseAppSelector} from "../../redux/configure-store";
import {getTaxRateBrackets} from "../../redux/profile/selectors";
import _ from "lodash";
import { modalActions } from 'redux/root-action';





export const MarginalTaxRateModal = ({modalName,handleCloseModal,dispatchOverlayLoad}) => {
    const taxRateBrackets = UseAppSelector(getTaxRateBrackets);

    useEffect(() => {
        const overlay = "Marginal Tax Rate Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const taxRateArray : any= _.groupBy(taxRateBrackets, 'taxRate.minimum');
    let taxRateBracketsData :any = [];
    for (let taxRateArrayKey in taxRateArray) {
        let taxRateBracket = [];
        taxRateBracket.push({name:"rate", value: taxRateArrayKey})
        const taxBracketArray = taxRateArray[taxRateArrayKey];
        if(taxBracketArray[0].status.shortName !== "Single")
            taxRateBracket.push({name: "Single", value: ""})
        const taxRateBracketsArray = _.groupBy(taxBracketArray, 'status.shortName')
        for (const taxRateBracketsArrayKey in taxRateBracketsArray) {
            const maximumAmount = taxRateBracketsArray[taxRateBracketsArrayKey][1].incomeAmount;
            if (maximumAmount != 0)
                taxRateBracket.push({
                    name: taxRateBracketsArrayKey,
                    value: "$" + taxRateBracketsArray[taxRateBracketsArrayKey][0].incomeAmount.toLocaleString() + " to $" + maximumAmount.toLocaleString()
                })
            else
                taxRateBracket.push({
                    name: taxRateBracketsArrayKey,
                    value: "$" + taxRateBracketsArray[taxRateBracketsArrayKey][0].incomeAmount.toLocaleString() + " and up"
                })
        }
        taxRateBracketsData.push(taxRateBracket)
    }

    const headerNames = ["RATE", "SINGLE FILERS", "MARRIED JOINT FILERS", "MARRIED FILING SEPARATELY", "HEAD OF HOUSEHOLD FILERS"]

    const dispatch = UseAppDispatch();

    const closeThisModal = () => {
        dispatch(modalActions.closeModal());
    }

    return (
        <React.Fragment>
            <BeaconModal id={modalName}
                         onClose={closeThisModal}
                            footer={()=>{}}
                            opens-by="header-tooltip-1"
                >
                <ReactModalContent>
                    <ReactModalHeader modalTitle="Marginal Tax Rate Information"/>
                    Using your taxable income and your filing status, find your marginal tax rate on this chart. You will need to estimate your state taxes.
                </ReactModalContent>
                <ReactModalContent>
                    <Table headerNames={headerNames} tableColumnData={taxRateBracketsData} isMarginalTaxRateModal={true} borderless={false} />
                </ReactModalContent>
            </BeaconModal>
        </React.Fragment>
    )
}

